import { render } from "./SetupAccount.vue?vue&type=template&id=336eb4a4"
import script from "./SetupAccount.vue?vue&type=script&lang=js"
export * from "./SetupAccount.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src3554799265/src/syndesi-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__